import React from 'react';

const MusicServiceSelector = ({ selectedService, onServiceChange }) => {
    const services = [
        { id: 'spotify', name: 'Spotify' },
        { id: 'appleMusic', name: 'Apple Music' },
        { id: 'youtubeMusic', name: 'YouTube Music' },
        { id: 'amazonMusic', name: 'Amazon Music' },
        { id: 'tidal', name: 'Tidal' },
        { id: 'deezer', name: 'Deezer' },
        { id: 'qobuz', name: 'Qobuz' }
    ];

    return (
        <div className="flex flex-col gap-6 text-amber-50 pangram-sans-bold text-center">
            <div className="uppercase max-sm:text-sm tracking-wider">
                Where do you listen?
            </div>
            
            <div className="relative w-full">
                <select
                    value={selectedService}
                    onChange={(e) => onServiceChange(e.target.value)}
                    className="
                            xl:w-[36rem] lg:w-[28rem] md:w-[24rem] w-[18rem]
                            px-8 md:py-4 py-2 text-center outline-none bg-transparent
                            border-4 border-solid border-amber-50 text-amber-50 rounded-full

                            xl:text-5xl lg:text-4xl md:text-3xl text-2xl
                            uppercase pangram-sans-bold tracking-wider

                            cursor-pointer appearance-none
                            [-webkit-appearance:none]
                            [text-align-last:center]"
                >
                    {services.map(service => (
                        <option 
                            key={service.id} 
                            value={service.id}
                            className="text-center"
                        >
                            {service.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default MusicServiceSelector;